<template>
  <el-container>
    <el-header height="150px">
      <top-header></top-header>
      <top-nav></top-nav>
    </el-header>
    <el-main>
      <router-view/>
    </el-main>
    <el-footer>
      <bottom-footer></bottom-footer>
    </el-footer>
  </el-container>
  <!--<div id="app"  class="main-page">

  </div>-->
</template>

<script>
  import TopHeader from 'src/components/TopHeader'
  import TopNav from 'src/components/TopNav'
  import BottomFooter from 'src/components/BottomFooter'

  export default {
    name: 'App',
    components: {
      TopHeader,
      BottomFooter,
      TopNav
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue